import { createSelector } from 'reselect';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import { localeSelector } from 'viewModel/selectors/locale/localeSelector';
import { GOOGLE_PAY_LEGAL_LINKS } from 'constants/GooglePay';
import PaymentEN from 'components/FrictionlessCheckout/PaymentReleaseFour/locales/Payment_en_US';
import PaymentFR from 'components/FrictionlessCheckout/PaymentReleaseFour/locales/Payment_fr_CA';

const { getLocalisedDataFromResource } = LanguageLocaleUtils;
const getText = getLocalisedDataFromResource(PaymentEN, PaymentFR);

const getGooglePayLegalLocaleKey = ({ isCanada, isFRCanada }) => {
    if (!isCanada) {
        return 'us';
    }

    return isFRCanada ? 'caFr' : 'caEn';
};

const googlePayLegalNoticeSelector = createSelector(localeSelector, () => {
    const isCanada = LanguageLocaleUtils.isCanada();
    const isFRCanada = LanguageLocaleUtils.isFRCanada();
    const localeKey = getGooglePayLegalLocaleKey({ isCanada, isFRCanada });
    // For fr_CA we read a hardcoded key that has no _en_US.js counterpart so the SDL translation bot cannot overwrite the legally-reviewed copy.
    const resourceKey = isFRCanada ? 'googlePayLegalNoticeHardcoded' : 'googlePayLegalNotice';

    return getText(resourceKey, [GOOGLE_PAY_LEGAL_LINKS.terms[localeKey], GOOGLE_PAY_LEGAL_LINKS.privacy[localeKey]]);
});

export default googlePayLegalNoticeSelector;
